import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col page-enter">
      <Seo
        title="Politique de confidentialité"
        description="Politique de confidentialité de Fiable ou Pas : données collectées, finalité, conservation, vos droits RGPD, cookies."
        path="/politique-de-confidentialite"
      />
      <Header />
      <main className="flex-1 py-12 bg-[#F9FAFB]">
        <div className="container-app max-w-3xl">
          <div className="card-base p-8 sm:p-10">
            <h1 className="text-3xl font-extrabold font-heading text-slate-900 mb-8">Politique de confidentialité</h1>

            <div className="space-y-6 text-sm text-slate-600 leading-relaxed">
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">1. Données collectées</h2>
                <p>
                  Lors de l'utilisation de Fiable ou Pas, les données suivantes peuvent être collectées :
                </p>
                <ul className="list-disc list-inside mt-2 space-y-1 text-slate-600">
                  <li>Les URLs soumises à l'analyse (pour permettre l'analyse et l'historique)</li>
                  <li>Les résultats d'analyse (score, signaux, date d'analyse)</li>
                  <li>Des données techniques anonymisées (logs d'accès, erreurs)</li>
                </ul>
                <p className="mt-2">
                  Aucune donnée personnelle identifiable (nom, email, numéro de téléphone) n'est collectée lors d'une analyse standard.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">2. Finalité du traitement</h2>
                <p>Les données collectées sont utilisées pour :</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Fournir le service d'analyse de sites web</li>
                  <li>Améliorer la précision du moteur de scoring</li>
                  <li>Analyser l'utilisation du service à des fins statistiques anonymisées</li>
                  <li>Assurer la sécurité et la disponibilité du service</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">3. Conservation des données</h2>
                <p>
                  Les résultats d'analyse sont conservés pour une durée limitée afin de permettre l'historique et l'amélioration du service.
                  Les données techniques sont conservées pour une durée maximale de 12 mois.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">4. Vos droits (RGPD)</h2>
                <p>Conformément au RGPD, vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Droit d'accès à vos données</li>
                  <li>Droit de rectification</li>
                  <li>Droit à l'effacement ("droit à l'oubli")</li>
                  <li>Droit à la limitation du traitement</li>
                  <li>Droit d'opposition</li>
                </ul>
                <p className="mt-2">
                  Pour exercer ces droits, contactez-nous via la <a href="/contact" className="text-[#1E3A8A] underline">page contact</a>.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">5. Cookies</h2>

                <p>
                  Fiable ou Pas utilise des cookies techniques strictement nécessaires au
                  fonctionnement du service (session, préférences).
                </p>

                <p className="mt-2">
                  Fiable ou Pas peut utiliser Google AdSense, un service de publicité fourni
                  par Google LLC. Lorsque des annonces sont affichées, Google AdSense peut
                  déposer des cookies sur votre appareil afin de personnaliser ou mesurer les
                  annonces, selon votre consentement et les paramètres applicables.
                </p>

                <p className="mt-2">
                  Vous pouvez gérer la personnalisation des annonces depuis{" "}
                  <a
                    href="https://www.google.com/settings/ads"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#1E3A8A] underline"
                  >
                    la page de paramètres publicitaires de Google
                  </a>.
                </p>

                <p className="mt-2">
                  Pour en savoir plus sur l&apos;utilisation des cookies par Google, consultez la{" "}
                  <a
                    href="https://policies.google.com/technologies/ads"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#1E3A8A] underline"
                  >
                    politique de confidentialité de Google
                  </a>.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">6. Contact et réclamations</h2>
                <p>
                  Pour toute question relative à vos données personnelles ou pour exercer vos droits, contactez-nous via la{" "}
                  <a href="/contact" className="text-[#1E3A8A] underline">page contact</a>.
                </p>
                <p className="mt-2">
                  Vous avez également le droit d'introduire une réclamation auprès de la{" "}
                  <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#1E3A8A] underline">
                    CNIL
                  </a>{" "}
                  (Commission Nationale de l'Informatique et des Libertés).
                </p>
              </section>

              <p className="text-xs text-slate-400 pt-4 border-t border-slate-100">
                Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
